import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { DEFAULT_PLAN_TYPE } from "../../../consts/planTypes";
import { palette } from "../../../theme/palette";

import {
  depotSummaryInformation,
  getMatrixProfileType,
  areasWaveSplitSelector,
  driverlessRoutesSelector,
} from "../../../reducers/matrixProfile/selectors";

import { numberWithCommas } from "../../../utils/routes";

import { View } from "../../Base";
import KeyValue from "../KeyValue";
import UnallocatedPostcodeComponent from "../UnallocatedPostcodeComponent";
import SingleWaveComponent from "../SingleWaveComponent";
import DriverlessRoutesComponent from "../DriverlessRoutesComponent";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginLeft: "10px",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  clockIcon: {
    width: "16px",
    height: "16px",
  },
  warningIcon: {
    width: "16px",
    height: "14.45",
  },
  questionMarkIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const DefaultSummaryPanel = () => {
  const styles = useStyles();
  const depotSummaryInfo = useSelector(depotSummaryInformation);
  const planType = useSelector(getMatrixProfileType);
  const { unallocatedAreas, singleWaveAreas } = useSelector(
    areasWaveSplitSelector
  );
  const driverlessRoutes = useSelector(driverlessRoutesSelector);

  return (
    <View className={styles.container}>
      <KeyValue
        property={"Routes Planned"}
        value={numberWithCommas(depotSummaryInfo?.totalAllocated || 0)}
      />
      <KeyValue
        property={"Routes Available"}
        value={numberWithCommas(depotSummaryInfo?.totalUnplanned || 0)}
      />
      <KeyValue
        property={"Collections"}
        value={numberWithCommas(depotSummaryInfo?.totalCollections || 0)}
      />

      {planType === DEFAULT_PLAN_TYPE && (
        <UnallocatedPostcodeComponent unallocatedAreas={unallocatedAreas} />
      )}
      {planType === DEFAULT_PLAN_TYPE && (
        <SingleWaveComponent singleWaveAreas={singleWaveAreas} />
      )}
      <DriverlessRoutesComponent driverlessRoutes={driverlessRoutes} />
    </View>
  );
};

export default DefaultSummaryPanel;
